import { skipToken } from '@reduxjs/toolkit/dist/query/react';
import { useMemo } from 'react';
import { useGetRanchQuery } from '../impl/blfApi/endpoints/ranches';

export const useRanch = (
  ranchId: string | undefined,
  queryOptions?: {
    skip?: boolean;
  }
) => {
  const queryParams = useMemo(() => {
    if (!ranchId || queryOptions?.skip) {
      return skipToken;
    }

    return ranchId;
  }, [ranchId, queryOptions?.skip]);

  const {
    data: ranch,
    isLoading,
    isFetching,
  } = useGetRanchQuery(queryParams, queryOptions);
  return { ranch, isRanchLoading: isLoading || isFetching };
};
